import React from "react";
import { useTheme } from "@material-ui/core";

export const UsersHelpImg = () => {
  const theme = useTheme();
  const color = theme.palette.primary.main;
  const secondary = theme.palette.secondary.main;
  return (
    <svg
      width="100%"
      height="200px"
      viewBox="0 0 295 189"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0)">
        <path d="M295 0.166992H0.125977V189H295V0.166992Z" fill="#E2E2E2" />
        <path
          d="M286.568 20.7324H8.55762V180.894H286.568V20.7324Z"
          fill="white"
        />
        <path d="M294.874 0H0V12.5262H294.874V0Z" fill={color} />
        <path
          d="M9.30957 8.91847C10.6984 8.91847 11.8242 7.79273 11.8242 6.40406C11.8242 5.01539 10.6984 3.88965 9.30957 3.88965C7.92077 3.88965 6.79492 5.01539 6.79492 6.40406C6.79492 7.79273 7.92077 8.91847 9.30957 8.91847Z"
          fill="white"
        />
        <path
          d="M18.1226 8.91847C19.5114 8.91847 20.6372 7.79273 20.6372 6.40406C20.6372 5.01539 19.5114 3.88965 18.1226 3.88965C16.7338 3.88965 15.6079 5.01539 15.6079 6.40406C15.6079 7.79273 16.7338 8.91847 18.1226 8.91847Z"
          fill="white"
        />
        <path
          d="M26.9355 8.91847C28.3243 8.91847 29.4502 7.79273 29.4502 6.40406C29.4502 5.01539 28.3243 3.88965 26.9355 3.88965C25.5467 3.88965 24.4209 5.01539 24.4209 6.40406C24.4209 7.79273 25.5467 8.91847 26.9355 8.91847Z"
          fill="white"
        />
        <path
          d="M177.691 57.1733H117.805V109.473H177.691V57.1733Z"
          fill="#E2E2E2"
        />
        <path
          d="M138.489 61.0166L140.328 68.3691L139.54 79.1355L146.63 84.6498L148.994 66.2684L147.681 61.8045L138.489 61.0166Z"
          fill="#FFB8B8"
        />
        <path
          d="M145.054 77.5597L146.367 70.4697L148.993 65.4805L155.559 92.0022L140.59 94.1029L136.65 72.8333L140.009 67.099L142.428 71.5201L145.054 77.5597Z"
          fill="white"
        />
        <path
          d="M161.945 109.473H137.042L137.176 107.495L142.952 103.82H150.831L161.862 108.547L161.945 109.473Z"
          fill="#2F2E41"
        />
        <path
          d="M143.479 64.9554C146.959 64.9554 149.781 62.1338 149.781 58.6532C149.781 55.1727 146.959 52.3511 143.479 52.3511C139.998 52.3511 137.176 55.1727 137.176 58.6532C137.176 62.1338 139.998 64.9554 143.479 64.9554Z"
          fill="#FFB8B8"
        />
        <path
          d="M167.377 89.1148L161.337 84.1237L161.941 97.1777L161.999 98.4307L162.075 100.086L162.243 103.698L162.511 109.473H149.363L148.467 106.707L148.11 109.473H136.086C136.002 108.023 135.956 106.276 136.032 104.511C136.078 102.893 136.284 101.283 136.648 99.7047C136.873 98.6318 137.322 97.6181 137.964 96.7293L135.6 88.327L134.548 93.5779L127.197 94.1017C127.197 94.1017 127.201 93.9676 127.214 93.7162V93.712C127.318 91.1263 128.094 76.4925 131.924 73.6219L139.724 65.9571C139.724 65.9571 139.728 66.5144 139.804 67.4531V67.4573C139.862 68.2536 139.971 69.3222 140.168 70.5585V70.571C140.608 73.3578 141.48 76.9828 143.215 80.1845C143.856 81.3662 144.376 82.372 144.799 83.2269C146.631 86.9356 146.631 87.8031 146.631 87.8031L147.389 78.7638L147.394 78.7303L147.398 78.6968L148.408 66.5941L148.559 64.7879V64.7837C148.559 64.7837 160.549 66.7952 164.225 72.3102C167.18 76.7356 172.674 83.8807 174.719 86.5166C174.745 86.5459 174.766 86.5753 174.791 86.6046L175.097 87.0027C175.155 87.0782 175.21 87.1452 175.256 87.2081C175.306 87.2709 175.348 87.3212 175.382 87.3673L175.516 87.5391L167.377 89.1148Z"
          fill={color}
        />
        <path
          d="M147.156 92.5272C147.591 92.5272 147.943 92.1745 147.943 91.7394C147.943 91.3044 147.591 90.9517 147.156 90.9517C146.72 90.9517 146.368 91.3044 146.368 91.7394C146.368 92.1745 146.72 92.5272 147.156 92.5272Z"
          fill="#2F2E41"
        />
        <path
          d="M148.206 99.6175C148.641 99.6175 148.994 99.2648 148.994 98.8298C148.994 98.3947 148.641 98.042 148.206 98.042C147.771 98.042 147.418 98.3947 147.418 98.8298C147.418 99.2648 147.771 99.6175 148.206 99.6175Z"
          fill="#2F2E41"
        />
        <path
          d="M164.225 101.718L161.862 104.081L160.286 99.8799L161.999 98.4321L164.225 101.718Z"
          fill="#FFB8B8"
        />
        <path
          d="M134.287 102.769L136.651 105.132L137.176 99.8803L135.6 99.355L134.287 102.769Z"
          fill="#FFB8B8"
        />
        <path
          d="M136.125 53.8031C136.125 53.8031 134.287 51.4713 136.125 50.3054V50.8883C136.125 50.8883 140.065 46.5162 142.428 47.6821L144.529 47.0991V47.6821L145.842 47.0991L145.579 47.9736H147.418L146.63 48.5565C146.63 48.5565 152.67 48.265 148.993 52.6372C148.993 52.6372 150.741 55.2585 149.079 56.7168C149.079 56.7168 147.68 53.5116 145.842 54.386C145.344 54.6445 144.782 54.7545 144.224 54.7028C143.665 54.6511 143.133 54.44 142.691 54.0945C142.691 54.0945 139.014 53.8031 139.539 55.5519C140.065 57.3008 139.802 57.8837 139.802 57.8837C139.802 57.8837 138.489 58.7581 138.751 59.3411C139.014 59.924 139.014 61.6729 139.014 61.6729C139.014 61.6729 137.701 59.6326 137.176 59.924C136.651 60.2155 133.762 57.3008 136.125 53.8031Z"
          fill="#2F2E41"
        />
        <path
          d="M128.247 93.0528L127.196 93.7258V94.3658C127.256 95.4916 127.619 96.5803 128.247 97.5168C129.297 99.0924 135.075 104.344 135.075 104.344L136.65 98.8298L134.55 93.578L133.236 92.0024L128.247 93.0528Z"
          fill={color}
        />
        <path
          d="M171.841 86.2251L174.722 86.5175L175.517 87.538C175.517 87.538 176.043 89.9014 174.992 91.2143C173.942 92.5273 164.75 103.293 164.75 103.293L160.811 98.5668L167.639 90.1639L167.376 89.1136L171.841 86.2251Z"
          fill={color}
        />
        <path
          d="M268.385 56.6597H207.911V109.472H268.385V56.6597Z"
          fill="#E2E2E2"
        />
        <path
          d="M245.274 68.1401L231.618 68.4026L229.779 55.7983H245.274V68.1401Z"
          fill="#2F2E41"
        />
        <path
          d="M251.971 70.1094C251.971 70.1094 256.698 70.1094 257.223 75.0986C257.748 80.0878 255.91 92.9547 255.91 92.9547L254.334 109.498H250.632L250.92 96.8936L251.971 78.7749L248.819 75.3612L251.971 70.1094Z"
          fill="#A0616A"
        />
        <path
          d="M232.537 70.109C232.537 70.109 228.073 69.0587 223.871 75.0982C223.871 75.0982 213.104 82.976 216.518 85.8644C219.932 88.7529 229.123 90.5911 229.123 90.5911C229.123 90.5911 225.709 97.681 227.81 97.9436C229.911 98.2062 233.063 90.3285 232.275 89.0155C231.487 87.7026 228.598 86.9148 228.598 86.9148L221.77 83.5012C221.77 83.5012 230.531 75.9758 231.009 79.2133L233.588 77.9868L232.537 70.109Z"
          fill="#A0616A"
        />
        <path
          d="M242.254 61.1812C242.809 63.0648 243.782 64.7988 245.101 66.2538C246.419 67.7088 248.05 68.8472 249.87 69.584L243.042 75.361L234.901 70.1092C234.901 70.1092 237.79 68.2711 237.002 64.3322L242.254 61.1812Z"
          fill="#A0616A"
        />
        <path
          d="M237.001 65.3827C240.482 65.3827 243.304 62.5611 243.304 59.0805C243.304 55.5999 240.482 52.7783 237.001 52.7783C233.521 52.7783 230.699 55.5999 230.699 59.0805C230.699 62.5611 233.521 65.3827 237.001 65.3827Z"
          fill="#A0616A"
        />
        <path
          d="M231.487 69.584L236.28 68.6445C236.28 68.6445 237.79 72.21 242.779 71.6848C247.769 71.1596 248.648 69.0046 248.648 69.0046L253.284 70.1092C253.284 70.1092 250.658 72.9977 251.971 78.7747C251.971 78.7747 252.496 88.2279 249.607 91.6416L249.345 96.8934C249.345 96.8934 252.759 105.822 250.92 109.498H225.184C225.184 109.498 226.235 96.3683 230.962 92.9546L232.012 90.5913C232.012 90.5913 229.911 81.4006 230.962 79.8251C230.962 79.8251 231.749 69.8466 231.487 69.584Z"
          fill={color}
        />
        <path
          d="M248.984 65.0021C247.554 64.2165 246.888 62.4532 246.841 60.8218C246.793 59.1904 247.189 57.5758 247.22 55.944C247.236 55.6102 247.207 55.2757 247.135 54.9494C247.017 54.5443 246.832 54.1616 246.588 53.8169C244.727 50.9663 241.493 48.9611 238.087 48.9295C237.595 48.9231 237.106 49.0129 236.648 49.194C236.296 49.335 236.181 49.3177 236.113 49.7501C235.306 49.4839 234.431 49.5118 233.643 49.8287C232.862 50.1461 232.133 50.5799 231.482 51.1152C231.095 51.403 230.73 51.7191 230.39 52.0609C228.59 53.9258 228.175 56.7999 228.697 59.3388C228.866 60.1642 228.053 60.9611 227.38 61.4681C226.706 61.9751 225.929 62.4406 225.598 63.2158C225.281 63.9614 225.455 64.8142 225.391 65.6222C225.319 66.3861 225.035 67.1147 224.571 67.7257C224.107 68.3368 223.482 68.806 222.765 69.0804C222.911 69.2554 223.102 69.3877 223.317 69.4633C223.532 69.539 223.764 69.5552 223.987 69.5102C224.454 69.4119 224.891 69.2041 225.261 68.9039C226.654 67.8715 227.651 66.3924 228.085 64.7136C228.283 65.6128 228.206 66.5403 228.199 67.4609C228.216 68.4883 228.027 69.5088 227.643 70.4617C227.251 71.4191 226.535 72.2079 225.619 72.6892C226.503 73.1215 227.476 72.8081 228.224 72.1704C228.941 71.4896 229.459 70.6264 229.723 69.6734C230.225 68.1523 230.428 66.5485 230.322 64.9502C231.144 66.3329 231.444 67.9635 231.169 69.5481C230.881 71.1635 230.038 72.6276 228.784 73.6865C230.97 73.668 233.119 73.1268 235.053 72.108C235.552 71.8817 235.993 71.5428 236.339 71.1178C236.961 70.2547 236.814 69.0775 236.639 68.0279C236.501 67.198 237.538 65.9983 236.945 65.4024C236.791 65.2473 236.588 65.1506 236.371 65.1289C234.221 64.8219 232.287 63.5873 231.356 61.6255C230.953 60.819 230.733 59.9338 230.71 59.0327C230.71 58.0859 230.923 57.1513 231.335 56.2983C231.746 55.4454 232.344 54.696 233.084 54.1059C233.825 53.5158 234.689 53.1001 235.612 52.8897C236.535 52.6793 237.494 52.6796 238.417 52.8906C239.34 53.1016 240.204 53.5178 240.944 54.1084C241.684 54.699 242.282 55.4487 242.692 56.3019C243.103 57.1551 243.316 58.0899 243.316 59.0367C243.315 59.9835 243.102 60.9181 242.69 61.771C242.622 63.0414 242.411 64.3 242.062 65.5234C241.613 67.0881 240.852 68.6845 239.443 69.5006C239.936 69.7116 240.465 69.8236 241.001 69.8304C242.768 70.0252 244.627 69.9822 246.227 69.2059C247.827 68.4296 249.098 66.7766 248.984 65.0021Z"
          fill="#2F2E41"
        />
        <path
          d="M244.486 57.6362C239.761 55.7427 235.104 55.3388 230.567 57.6362V53.8197C230.567 53.4933 230.632 53.17 230.757 52.8684C230.882 52.5669 231.065 52.2928 231.296 52.062C231.526 51.8312 231.8 51.6481 232.102 51.5232C232.404 51.3983 232.727 51.334 233.053 51.334H242.522C243.043 51.334 243.542 51.5409 243.911 51.9091C244.279 52.2774 244.486 52.7769 244.486 53.2977V57.6362Z"
          fill="#2F2E41"
        />
        <path
          d="M243.305 59.9992C243.849 59.9992 244.289 59.2938 244.289 58.4237C244.289 57.5535 243.849 56.8481 243.305 56.8481C242.761 56.8481 242.32 57.5535 242.32 58.4237C242.32 59.2938 242.761 59.9992 243.305 59.9992Z"
          fill="#A0616A"
        />
        <path
          d="M91.1186 57.0142H31.0479V109.473H91.1186V57.0142Z"
          fill="#E2E2E2"
        />
        <path
          d="M65.3904 69.6537L52.5225 69.3912V51.5352L65.3904 52.848V69.6537Z"
          fill="#2F2E41"
        />
        <path
          d="M77.175 109.473H49.3672C49.5476 108.462 49.8575 107.479 50.2892 106.548C51.0772 105.102 52.0621 101.951 52.85 99.1596C53.3068 97.542 53.6966 96.0459 53.9439 95.0779C54.1241 94.3696 54.2289 93.9422 54.2289 93.9422L67.8834 88.4272C67.8834 88.4272 68.269 89.1271 68.8893 90.3047C68.8975 90.3223 68.9073 90.3391 68.9186 90.3549C69.3587 91.1889 69.9119 92.2617 70.5238 93.4896H70.528C72.766 97.9485 75.8213 104.494 77.175 109.473Z"
          fill="#2F2E41"
        />
        <path
          d="M55.1484 62.0381L53.3101 71.2288L59.6128 71.7539C59.6128 71.7539 60.6633 63.6136 60.9259 63.351C61.1885 63.0884 55.1484 62.0381 55.1484 62.0381Z"
          fill="#FFB8B8"
        />
        <path
          d="M59.2188 65.058C62.6997 65.058 65.5215 62.2364 65.5215 58.7558C65.5215 55.2752 62.6997 52.4536 59.2188 52.4536C55.7379 52.4536 52.916 55.2752 52.916 58.7558C52.916 62.2364 55.7379 65.058 59.2188 65.058Z"
          fill="#FFB8B8"
        />
        <path
          d="M53.3099 68.603C53.3099 68.603 59.3501 69.916 59.6127 69.6534C59.8753 69.3908 66.9659 70.7037 67.4911 73.067C68.0164 75.4304 66.7033 84.621 66.7033 84.621C66.7033 84.621 69.592 85.934 69.3294 86.4592C69.0668 86.9843 70.9051 87.5095 70.3799 88.2973C69.8546 89.0851 60.4005 102.74 55.9361 102.477C51.4716 102.215 43.3306 72.5419 43.3306 72.5419C43.3306 72.5419 43.5932 68.8656 47.0072 68.8656C50.4212 68.8656 53.3099 68.603 53.3099 68.603Z"
          fill={color}
        />
        <path
          d="M70.5115 89.7417C70.5115 89.7417 66.8303 90.5747 67.4891 92.2589C68.1479 93.9431 72.0872 93.4179 72.0872 93.4179L70.5115 89.7417Z"
          fill="#FFB8B8"
        />
        <path
          d="M59.0236 109.473H49.3673C49.338 109.624 49.3045 109.779 49.2709 109.934C48.8063 109.742 48.327 109.588 47.8376 109.473C47.7286 109.448 47.6657 109.435 47.6657 109.435C47.6657 109.435 45.5619 101.557 42.6742 91.8428C40.1134 83.2225 42.7161 74.3928 43.3364 72.5111V72.507C43.416 72.2723 43.4621 72.1466 43.4621 72.1466L45.8259 70.311L53.944 95.078L56.0689 101.557C56.0689 101.557 56.1359 101.917 56.2491 102.475C56.5928 104.134 57.3807 107.533 58.1686 108.124C58.5612 108.495 58.8551 108.959 59.0236 109.473Z"
          fill={color}
        />
        <path
          d="M63.9463 72.1479L67.2235 72.4882L74.7135 81.8638C74.7135 81.8638 77.6023 84.4897 75.764 85.54C73.9257 86.5904 73.1378 88.6911 73.1378 88.6911C73.1378 88.6911 75.5014 93.9429 72.0874 94.7307C72.0874 94.7307 69.7238 89.4789 68.936 88.9537C68.1481 88.4285 69.9864 86.3278 69.9864 86.3278L63.9463 82.3889L63.9463 72.1479Z"
          fill={color}
        />
        <path
          d="M59.2189 48.5149C59.2189 48.5149 51.8657 47.2019 50.5526 53.7667C50.2378 55.2909 50.0299 56.8353 49.9303 58.3884C49.7237 62.1926 48.6808 65.9044 46.876 69.2595L58.6937 72.6732C58.6937 72.6732 55.5423 67.684 56.0675 65.5833C56.1649 65.0564 56.1575 64.5154 56.046 63.9913C54.8208 63.2364 53.891 62.0848 53.4112 60.7281C52.9314 59.3715 52.9304 57.8914 53.4086 56.5342C53.8867 55.1769 54.8151 54.0242 56.0394 53.2677C57.2636 52.5113 58.71 52.1966 60.1379 52.3762C61.5658 52.5557 62.8892 53.2185 63.888 54.2545C64.8869 55.2904 65.501 56.6371 65.6283 58.0704C65.7555 59.5038 65.3882 60.9375 64.5875 62.1332C63.7867 63.3289 62.6008 64.2145 61.2268 64.6427C60.348 66.5546 59.8699 68.6227 61.0572 70.0473C62.5575 71.8806 64.3286 73.4745 66.3095 74.7739C66.3095 74.7739 64.9964 68.4718 67.0973 64.7955C69.1983 61.1192 67.0973 49.0401 59.2189 48.5149Z"
          fill="#2F2E41"
        />
        <path
          d="M65.7495 56.9362L53.4278 57.6589L53.0889 51.8864L63.8127 51.501L65.7495 56.9362Z"
          fill="#2F2E41"
        />
        <path
          d="M33.5159 131.114C34.6733 131.114 35.6115 130.175 35.6115 129.018C35.6115 127.861 34.6733 126.923 33.5159 126.923C32.3586 126.923 31.4204 127.861 31.4204 129.018C31.4204 130.175 32.3586 131.114 33.5159 131.114Z"
          fill="#E2E2E2"
        />
        <path
          d="M33.5159 142.848C34.6733 142.848 35.6115 141.91 35.6115 140.753C35.6115 139.595 34.6733 138.657 33.5159 138.657C32.3586 138.657 31.4204 139.595 31.4204 140.753C31.4204 141.91 32.3586 142.848 33.5159 142.848Z"
          fill="#E2E2E2"
        />
        <path
          d="M33.5159 154.581C34.6733 154.581 35.6115 153.643 35.6115 152.486C35.6115 151.329 34.6733 150.391 33.5159 150.391C32.3586 150.391 31.4204 151.329 31.4204 152.486C31.4204 153.643 32.3586 154.581 33.5159 154.581Z"
          fill="#E2E2E2"
        />
        <path
          d="M82.1326 127.342H42.3174V130.694H82.1326V127.342Z"
          fill="#E2E2E2"
        />
        <path
          d="M82.1326 139.076H42.3174V142.429H82.1326V139.076Z"
          fill="#E2E2E2"
        />
        <path
          d="M82.1326 150.81H42.3174V154.163H82.1326V150.81Z"
          fill="#E2E2E2"
        />
        <path
          d="M124.488 131.114C125.645 131.114 126.583 130.175 126.583 129.018C126.583 127.861 125.645 126.923 124.488 126.923C123.33 126.923 122.392 127.861 122.392 129.018C122.392 130.175 123.33 131.114 124.488 131.114Z"
          fill="#E2E2E2"
        />
        <path
          d="M124.488 142.848C125.645 142.848 126.583 141.91 126.583 140.753C126.583 139.595 125.645 138.657 124.488 138.657C123.33 138.657 122.392 139.595 122.392 140.753C122.392 141.91 123.33 142.848 124.488 142.848Z"
          fill="#E2E2E2"
        />
        <path
          d="M124.488 154.581C125.645 154.581 126.583 153.643 126.583 152.486C126.583 151.329 125.645 150.391 124.488 150.391C123.33 150.391 122.392 151.329 122.392 152.486C122.392 153.643 123.33 154.581 124.488 154.581Z"
          fill="#E2E2E2"
        />
        <path
          d="M173.104 127.342H133.289V130.694H173.104V127.342Z"
          fill="#E2E2E2"
        />
        <path
          d="M173.104 139.076H133.289V142.429H173.104V139.076Z"
          fill="#E2E2E2"
        />
        <path
          d="M173.104 150.81H133.289V154.163H173.104V150.81Z"
          fill="#E2E2E2"
        />
        <path
          d="M214.888 131.114C216.045 131.114 216.983 130.175 216.983 129.018C216.983 127.861 216.045 126.923 214.888 126.923C213.73 126.923 212.792 127.861 212.792 129.018C212.792 130.175 213.73 131.114 214.888 131.114Z"
          fill="#E2E2E2"
        />
        <path
          d="M214.888 142.848C216.045 142.848 216.983 141.91 216.983 140.753C216.983 139.595 216.045 138.657 214.888 138.657C213.73 138.657 212.792 139.595 212.792 140.753C212.792 141.91 213.73 142.848 214.888 142.848Z"
          fill="#E2E2E2"
        />
        <path
          d="M214.888 154.581C216.045 154.581 216.983 153.643 216.983 152.486C216.983 151.329 216.045 150.391 214.888 150.391C213.73 150.391 212.792 151.329 212.792 152.486C212.792 153.643 213.73 154.581 214.888 154.581Z"
          fill="#E2E2E2"
        />
        <path
          d="M263.504 127.342H223.689V130.694H263.504V127.342Z"
          fill="#E2E2E2"
        />
        <path
          d="M263.504 139.076H223.689V142.429H263.504V139.076Z"
          fill="#E2E2E2"
        />
        <path
          d="M263.504 150.81H223.689V154.163H263.504V150.81Z"
          fill="#E2E2E2"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="295" height="189" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
